export default __webpack_public_path__ + "assets/images/26f4b0b58800fcbc729c8a807768e90f.jpg";